<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ dialogData?.title | translate }}
  </h1>
  <ng-container>
    <div mat-dialog-content>
      <div class="description">
        <p>
          {{ dialogData?.mainText | translate }}
          <ng-container *ngIf="dialogData?.highlightedText">
            <span class="highlight-text">{{ dialogData?.highlightedText }} </span>
            ?
          </ng-container>
        </p>

        <p *ngIf="dialogData?.additionalTextBlock" [innerHTML]="dialogData?.additionalTextBlock"></p>
      </div>
    </div>
    <div mat-dialog-actions class="tw-flex tw-justify-between">
      <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
      <ui-action-button
        [action]="dialogData?.buttonAction"
        [type]="!!dialogData ? dialogData.buttonType : buttonType.Secondary"
        (buttonClick)="confirm()"
      ></ui-action-button>
    </div>
  </ng-container>
</div>
